import { VoidCallback1 } from '@deqo/foundation';
import React, { useCallback, useState } from 'react';
import { Icon, NoIcon } from '../../concepts/resources/Icon';
import { LabelValue } from '../../platform/types/LabelValue';
import { MenuButton } from '../../ui/MenuButton';
import { SortMode } from '../common/Sorter';
import { Menu } from './../../ui';

const modifiers = [
    LabelValue('Ascending', 'asc'),
    LabelValue('Descending', 'desc'),
];

export type SortModeSelectorProps = { options: LabelValue[], value: SortMode, onChange: VoidCallback1<SortMode> };

export const SortModeSelector = ({ options, value, onChange }: SortModeSelectorProps) => {

    const [open, setOpen] = useState(false);
    value = value || [options[0].value, 'asc'] as SortMode;

    const opt = options.find(x => x.value === value[0]);
    const mod = modifiers.find(x => x.value === value[1]);

    const onSetOption = useCallback((o: LabelValue) => {
        onChange([o.value, mod.value] as SortMode);
    }, [onChange, mod]);

    const onSetModifier = useCallback((m: LabelValue) => {
        onChange([opt.value, m.value] as SortMode);
    }, [onChange, opt]);

    return <MenuButton block label={opt.label} {...{ open, setOpen }}>
        <Menu>
            {options.map(x =>
                <Menu.Item key={x.value} onClick={() => onSetOption(x)}>
                    {x.value === value[0] ? <Icon size="1" src="deqo://icons/hero/check" /> : <NoIcon />}
                    <Menu.ItemText>{x.label}</Menu.ItemText>
                </Menu.Item>
            )}
            <Menu.Divide />
            {modifiers.map(x =>
                <Menu.Item key={x.value} onClick={() => onSetModifier(x)}>
                    {x.value === value[1] ? <Icon size="1" src="deqo://icons/hero/check" /> : <NoIcon />}
                    <Menu.ItemText>{x.label}</Menu.ItemText>
                </Menu.Item>
            )}
        </Menu>
    </MenuButton>;
};
